import type { ClientCustomDashboardInputGraphql } from '~/types/graphql-backend-types/gql-types'
import { useQuery } from '@tanstack/vue-query'
import { DASHBOARD_QUERY } from '~/queries/dashboard'

export function useDashboard(input: MaybeRefOrGetter<ClientCustomDashboardInputGraphql>) {
  const { query } = useGqlMikro()

  return useQuery({
    queryKey: ['dashboard', { input }],
    queryFn: async () => {
      const { data } = await query({
        query: DASHBOARD_QUERY,
        variables: { input: toValue(input) },
      })

      return data.getDashboardUrl
    },
  })
}
